export const FLEX_DRAWER_FILTER_DEFAULT_VALUES = {
  employeeFlex: true,
  employeeUsedAsFlex: false,
  clusterPreference1: false,
  clusterPreference2: false,
  costCenterPreference1: false,
  costCenterPreference2: false,
  functionPreference1: false,
  functionPreference2: false,
  availabilityOnSameDay: false,
  availabilityOverlap: false,
  balanceHours: '',
  dutyOverlap: false,
  pool: false,
  qualified: false,
  stepName: ''
};

export const DEFAULT_EMPLOYEE_FLEX_FILTER = {
  employeeFlex: true
};
